import { CertificacoesModel } from 'models/certificacoes/CertificacoesModel';
import { GenericService } from './Generic.service';

export class CertificacoesService extends GenericService {
    readonly URI: string = '/v1/certificacoes';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public inserir(data: CertificacoesModel) {
        return this.post('inserir', data);
    }

    public updateCertificated(id: Number, data: CertificacoesModel) {
        return this.put('update/' + id, data);
    }
    public deleteCertificated(id: Number) {
        return this.deleteByParams(id.toString());
    }

    public listarAll() {
        return this.get('');
    }
    public listarById(id: number) {
        return this.get('public/' + id);
    }

    public handleDownloadCertificado(file: FormData) {
        return this.postFormData('generate-html', file);
    }

    public handleGenerateCertificado(codigoCertificacao: number) {
        return this.getBlob('generate-certificate-pdf', { codigoCertificado: codigoCertificacao });
    }

    public sendEmailCertificado(codigoCertificado: number, email: string) {
        return this.post('send-email', { codigo: codigoCertificado, email });
    }

    // Método adicionado para chamar o novo endpoint de geração de PDF de teste.
    // Retorna um blob (PDF) que será baixado pelo cliente.
    public generateTestCertificate(data: any) {
        return this.postBlob('generate-test-certificate', data);
    }
}
